// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
// @ commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const WizardError = require('components/commons/wizardError/wizardError');

class CardPaymentPurchaseDeferralFetchError extends React.Component {
    render() {
        const {
            categoryError,
            descriptionError,
            immCard,
            onMainButtonClick,
            processDetail,
            productName,
        } = this.props;
        const cardAlias = immCard.getIn(['alias', 'current']);
        const errorMessage = formatText('cardPaymentPurchaseDeferralFetchError-cardPaymentPurchaseDeferralFetchError_errorTitle');
        const wizardErrorSubMessage = (
            <FormattedText
                value="cardPaymentPurchaseDeferralFetchError-cardPaymentPurchaseDeferralFetchError_errorMessage"
            />
        );
        const goBackButton = {
            label: (
                <FormattedText
                    injectedStrings={[cardAlias]}
                    value="cardPaymentPurchaseDeferralFetchError-cardPaymentPurchaseDeferralFetchError_goBackButton"
                />
            ),
            url: `/myprofile/cards/${immCard.get('cardId')}/movements`
        };

        return (
            <article className="card-payment-purchase-deferral-generic-error row no-gutter">
                <div className="col-xs-offset-2 col-xs-8">
                    <WizardError
                        categoryError={categoryError}
                        descriptionError={descriptionError}
                        errorMessage={errorMessage}
                        errorSubMessage={wizardErrorSubMessage}
                        mainButton={goBackButton}
                        onMainButtonClick={onMainButtonClick}
                        processDetail={processDetail}
                        productName={productName}
                    >
                    </WizardError>
                </div>
            </article>
        );
    }
}

CardPaymentPurchaseDeferralFetchError.defaultProps = {
    onMainButtonClick: null,
}

CardPaymentPurchaseDeferralFetchError.propTypes = {
    categoryError: PropTypes.string,
    descriptionError: PropTypes.string,
    immCard: PropTypes.object.isRequired,
    onMainButtonClick: PropTypes.func,
    processDetail: PropTypes.string,
    productName: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
};

module.exports = CardPaymentPurchaseDeferralFetchError;
